import styled from "styled-components";
import { NavBar } from "../components/NavBar";
import bg from "./imgs/pending_verification_bg.png";
import icon from "./imgs/pending_icon.svg";
import Text from '../components/Text/Text';
import SimpleButton from "../components/Buttons/SimpleButton";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface PendingVerificationProps {
  theme: string;
  toggleTheme: any;
}

const PendingVerificationContainer = styled.div`
  background: url(${bg}) no-repeat center;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const Container = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background: #000D30;
border: 0.5px solid #ffffff90;
margin-top: 10%;
border-radius: 30px;
padding-inline: 5%;
padding-block: 2%;
text-align: center;

`;

const PendingVerificationPage = ({
  theme,
  toggleTheme,
}: PendingVerificationProps) => {
    const navigate = useNavigate();
    const auth = useAuth();
  return (
    <>
      <NavBar theme={theme} themeToggler={toggleTheme} />
      <PendingVerificationContainer>
        <Container>
            <Text style={{margin: 0}} size={'22px'}>Your verification is processing.
            <br/>
            <br/>
            Please check in again later.
            <br/>
            <br/>
            </Text>

            <img src={icon}/>
            
            <Text size={'14px'}>
            If you need help, please contact our team via email artistrelations@composenft.io
            </Text>
            <SimpleButton onClick={() => {navigate(`/user/${auth.user.wallet_address}`)}}>OK</SimpleButton>

        </Container>




      </PendingVerificationContainer>
    </>
  );
};

export default PendingVerificationPage;
